import React from 'react';

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t bg-background flex-shrink-0">
      <div className="px-4 py-2">
        <p className="text-center text-[11px] text-muted-foreground">
          © {currentYear} Created by <strong className="font-semibold">Pusat Data dan Teknologi Informasi</strong>
        </p>
      </div>
    </footer>
  );
}
